module.exports = __webpack_public_path__ + "img/27.4f2b3132.jpg";